<template>
	<div class="view view--resource resource">
		<!-- <EmbedHeader /> -->
			<div class="resource__sidebar">
				<div class="resource__logo">
					<router-link :to="{ name: 'main' }"
						><img
							src="~@/assets/images/correspondent-logo--white-text.png"
							alt="Correspondent Division"
							width="200"
					/></router-link>
				</div>
				<nav class="resource__nav">
					<router-link :to="{ name: 'main' }" class="resource__nav-item">
						<ion-icon name="apps"></ion-icon>
						<span>Home</span>
					</router-link>
					<details name="alist" open>
						<summary>
							<strong class="resource__title resource__title--alist"
								>A-List Resources</strong
							>
						</summary>
						<div class="resource__nav-items">
							<router-link
								v-for="(resource, idx) in alistResources"
								:to="{
									name: 'resourceView',
									params: { resourceId: resource.resourceId },
								}"
								class="resource__nav-item resource__nav-item--alist"
								:class="{
									'resource__nav-item--active':
										resource.resourceId == $route.params?.resourceId,
								}"
							>
								<ion-icon :name="resource.icon" v-if="resource.icon"></ion-icon>
								<span class="resource__nav-item-title">{{ resource.name }}</span>
							</router-link>
						</div>
					</details>
					<details v-for="(resources, cat) in groupedResources" :name="cat">
						<summary>
							<strong class="resource__title" v-html="ResourceCategory[cat]"></strong>
						</summary>
						<div class="resource__nav-items">
							<router-link
								v-for="(resource, idx) in resources"
								:to="{
									name: 'resourceView',
									params: { resourceId: resource.resourceId },
								}"
								class="resource__nav-item"
								:class="{
									'resource__nav-item--active':
										resource.resourceId == $route.params?.resourceId,
								}"
							>
								<ion-icon :name="resource.icon" v-if="resource.icon"></ion-icon>
								<span class="resource__nav-item-title">{{ resource.name }}</span>
							</router-link>
						</div>
					</details>
					<!-- <strong class="resource__title">Risk &amp; Analysis</strong>
				<router-link
					v-for="(resource, idx) in normalResources"
					:to="{name: 'resourceView', params: { resourceId: resource.resourceId}}"
					class="resource__nav-item"
					:class="{'resource__nav-item--active': resource.resourceId == $route.params?.resourceId}">
					<ion-icon :name="resource.icon" v-if="resource.icon"></ion-icon>
					<span class="resource__nav-item-title">{{resource.name}}</span>
				</router-link> -->
				</nav>
				<div class="resource__actions">
					<a @click="logout" class="resource__nav-item">
						<ion-icon name="exit"></ion-icon>
						<span>Logout</span>
					</a>
				</div>
			</div>
			<div class="resource__body">
				<div class="alist" v-if="resource.access == 'alist' && !hasAlist">
					<div class="alist__header">
						<span class="alist__header-tag">A-List</span>
						<h2 class="alist__header-title">Exclusive Tools for A-List Banks</h2>
					</div>
					<div class="alist__body">
						<h3 class="alist__body-title">
							<ion-icon name="lock-closed"></ion-icon>
							Membership Required
						</h3>
						<!-- <p class="alist__body-content">
							<strong>{{ resource.name }}</strong> is only available to A-List
							members.
						</p> -->
						<p class="alist__body-content">
							Learn how you and your bank can get on the A-List.
						</p>
						<div class="message success" v-if="message">
							<div class="message__body">
								<p class="message__content" v-html="message"></p>
							</div>
						</div>
						<button
							class="button button--raised button--secondary form__action"
							@click.prevent.stop="requestPrompt(resource)"
							:disabled="isLoading"
						>
							Request Access
						</button>
					</div>
				</div>
				<iframe v-else :src="iframeSrc" />
			</div>
	</div>
</template>

<script>
import EmbedHeader from "@/components/EmbedHeader.vue";
import { interpolate, groupByKey } from "@/lib/utils";
import { ResourceCategory } from "@/lib/enums";

export default {
	name: "PartialResource",
	components: {
		EmbedHeader,
	},
	asyncData: async ({ store, route }) => {
		store.dispatch("resource/list");
		return store.dispatch("resource/get", route.params?.resourceId);
	},
	data: () => ({
		ResourceCategory,
		isLoading: false,
		message: null,
	}),
	computed: {
		me() {
			return this.$store.getters["user/me"] || {};
		},
		hasAlist() {
			return this.me?.permissions?.alist;
		},
		resources() {
			return this.$store.getters["resource/resources"];
		},
		embeddedResources() {
			return this.resources.filter((r) => r.type === "embedded");
		},
		alistResources() {
			return this.embeddedResources.filter((r) => r.access === "alist");
		},
		normalResources() {
			return this.embeddedResources.filter((r) => r.access !== "alist");
		},
		groupedResources() {
			const grouped = groupByKey(this.normalResources, "category");
			return grouped;
		},
		resource() {
			return this.$store.getters["resource/resource"];
		},
		iframeSrc() {
			const params = {
				first_name: this.me.firstName,
				last_name: this.me.lastName,
				email: this.me.email,
				uid: this.me.uid,
				sfid: this.me.settings?.salesforceId,
				date_login: this.me.dateLogin,
				marketing_title: this.me.settings?.marketingTitle,
				org_name: this.me.organization?.name,
				org_id: this.me.organization?.orgId,
				org_snl: this.me.organization?.settings?.snlNumber,
				org_state: this.me.organization?.address?.state,
			};
			return interpolate(this.resource?.url || "", params);
		},
	},
	mounted() {
		const track = {
			event_name: "access",
			app: this.resource?.resourceId,
		};
		this.$store.dispatch(`user/trackMe`, track);
	},
	methods: {
		logout() {
			this.$store.dispatch("user/logout").then(() => {
				this.$router.push({ name: "login" });
			});
		},
		requestPrompt(resource) {
			this.isLoading = true;
			this.message = null;
			this.$store
				.dispatch("resource/requestInfo", resource.resourceId)
				.then((res) => {
					this.message = `Thank you for the request! We will be in touch shortly.`;
				})
				.catch((error) => {
					this.$notice(`ERROR: ${error.message || error}`);
					this.isLoading = false;
				})
				.finally(() => {});
			// this.$confirm(`Would you like to request access to our A-List Resources?`, () => {
			// }, {
			// 	title: `Request Access`,
			// 	acceptLabel: `Yes, Send Request`,
			// })
		},
	},
	watch: {
		$route(to, from) {
			if (from?.params?.resourceId && to.params?.resourceId !== from?.params?.resourceId) {
				this.$store.dispatch("resource/get", to.params.resourceId);

				const track = {
					event_name: "access",
					app: to.params.resourceId,
				};
				this.$store.dispatch(`user/trackMe`, track);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.partial {
	@include modules.gutter("padding", 0);
}

.resource {
	overflow-x: hidden;
	display: grid;
	grid-template-columns: 300px minmax(0, 1fr);
	height: 100vh;
	height: 100dvh;
	width: 100%;

	&__logo {
		@include modules.gutter("padding");
		border-bottom: 1px solid modules.color_("primary", "dark");
	}

	&__sidebar {
		background-color: modules.color_("primary");
		display: flex;
		flex-direction: column;
		min-height: 100dvh;
		overflow-y: auto;
		overscroll-behavior: contain;
	}

	&__body {
		min-height: 0;
		overflow: hidden;
		scrollbar-width: thin;
		scrollbar-color: white;
	}

	&__title {
		color: modules.color_("text", "base");
		text-transform: uppercase;
	}

	&__actions {
		border-top: 1px solid modules.color_("primary", "dark");
		@include modules.gutter("padding");
	}

	&__nav {
		@include modules.gutter("padding");
		display: flex;
		flex-direction: column;
		gap: 2rem;
		flex: 1;
		scrollbar-width: thin;
		scrollbar-color: modules.color_('primary');

		ion-icon {
			@include modules.fontSize(24px);
		}

		details {
			display: flex;
			flex-direction: column;
			gap: 1rem;

			summary {
				cursor: pointer;
				list-style: none;

				&::-webkit-details-marker {
					display: none;
				}

				strong {
					color: modules.color_("primary", "text");
					opacity: 0.8;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;

					&:after {
						content: "\203A";
						width: 0.5rem;
						height: 0.5rem;
						margin-left: 0.5rem;
						font-size: 1.2rem;
						line-height: 0.5rem;
						transition: transform 250ms ease;
					}
				}
			}
		}

		details[open] {
			summary {
				strong {
					&:after {
						transform: rotate(90deg);
					}
				}
			}
		}

		&-items {
			display: flex;
			flex-direction: column;
			gap: 1rem;
		}

		&-item {
			align-items: center;
			color: modules.color_("primary", "text");
			display: flex;
			flex-direction: row;
			gap: 0.75rem;
			@include modules.fontSize(16px);
			font-weight: 500;
			line-height: 1.375;
			letter-spacing: 0.25px;
			// margin-bottom: 2.5em;
			// margin-top: 2.5em;
			text-decoration: none;

			span {
				border-bottom: 1px solid transparent;
				transition: all 150ms linear;

				&:hover {
					// color: modules.color_("secondary", "dark");
					border-bottom-color: modules.color_("secondary");
				}
			}

			&--active {
				color: modules.color_("secondary");

				span {
					&:hover {
						border-bottom-color: modules.color_("secondary");
						color: modules.color_("secondary");
					}
				}
			}

			&--alist {
				ion-icon {
					color: modules.color_("secondary");
				}
			}
		}

		&-sep {
			@include modules.gutter("margin-bottom");
			@include modules.gutter("margin-top");
			background-color: #203155;
			display: block;
			height: 2px;
			width: 1.5rem;
		}
	}

	&__frame {
		min-height: 100dvh;
		height: 100%;
		scrollbar-width: thin;
		scrollbar-color: white;
	}

	iframe {
		display: block;
		border: 0;
		height: 100%;
		width: 100%;
	}
}

.alist {
	border: 1px solid modules.color_("border");
	border-radius: modules.$border-radius;
	margin: 1rem;

	&__header {
		@include modules.gutter("padding");
		background-color: modules.color_("primary");
		border-top-left-radius: modules.$border-radius;
		border-top-right-radius: modules.$border-radius;
		color: modules.color_("primary", "text");
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 0.75rem;

		&-tag {
			color: modules.color_("secondary");
			font-style: italic;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 0.35rem;
			margin: 0;

			&:before,
			&:after {
				content: "";
				display: block;
				height: 1px;
				width: 1.5rem;
				background-color: modules.color_("secondary");
			}
		}

		&-title {
			margin: 0;
		}
	}

	&__body {
		background-color: modules.color_("background", "light");
		border-bottom-left-radius: modules.$border-radius;
		border-bottom-right-radius: modules.$border-radius;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		padding: 1rem;

		&-title {
			margin: 0;
		}

		&-content {
			margin: 0;
		}
	}
}
</style>
